module.exports = __webpack_public_path__ + "static/img/IMG_20160918_150454.e1c27d63.jpg";